var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ToDoList',{scopedSlots:_vm._u([{key:"slot-entity-list",fn:function(ref){
var entity_list = ref.entity_list;
return [_c('div',_vm._l((entity_list),function(entity,index_entity){return _c('div',{key:index_entity},[_c('span',[_vm._v("name="+_vm._s(entity.name))])])}),0)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }